module.exports = __webpack_public_path__ + "static/img/p2.9625866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p2.png
// module id = yZ/M
// module chunks = 1